export default __webpack_public_path__ + "static/media/TELMI_Poziom_Biel-Kolor_animation1.33cc9900.svg";